import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import React, { useState } from 'react';
import { entitiesActions } from '@/store/entities';
import { adminKYCApi } from '@/api';
import { Container } from '@/ui';
import { Modal, Typography, Input } from 'antd';
import { usePopups } from '@/hooks';

export const AddProductContractNumber = ({ active, onClose, investorId, productId, onSubmit }) => {
  const { t } = useTranslation();
  const { showInfoToast, hideLoader } = usePopups();
  const dispatch = useDispatch();
  const [contractNumber, setContractNumber] = useState('');

  const addContractNumber = async () => {
    try {
      dispatch(entitiesActions.showLoader(t('Saving') + '...'));
      const result = await adminKYCApi.sendProductContractNumber({
        investorId: investorId,
        investorProductId: productId,
        numberContract: contractNumber
      });

      if (result) {
        onSubmit();
      }
      onClose();
    } catch (e) {
      console.error(e);
      showInfoToast(e, true);
    } finally {
      hideLoader();
    }
  };

  return (
    <Modal
      open={active}
      onCancel={onClose}
      title={t('Add contract number')}
      okText={t('Submit')}
      onOk={addContractNumber}
    >
      <Container $marginBottom={4}>
        <Typography.Text>{t('Add contract number')}</Typography.Text>
      </Container>
      <Input
        value={contractNumber}
        onChange={(e) => setContractNumber(e.target.value)}
      />
    </Modal>
  );
};
